import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TagAutocompleteOverride } from 'theme/overrides';
var TagAutocomplete = withStyles(TagAutocompleteOverride, {
  index: 1
})(Autocomplete);
export default TagAutocomplete;